<template>
  <a-layout>
    <Breadcrumb />
    <a-page-header title="组织机构管理" />
    <div class="content-container">
      <div class="tree-com">
        <a-tree
            v-if="treeData && treeData.length > 0"
            :tree-data="treeData"
            :replace-fields="areaTreeFields"
            defaultExpandAll
            show-icon
            :block-node="true"
        >
          <template slot="title" slot-scope="scope">
            <div class="titleName" :title="scope.deptName">
              {{ scope.deptName }}
            </div>
            <div class="action" v-if="scope.deptId" @click.stop="() => {}">
              <a-icon
                  type="arrow-up"
                  @click="onMove(scope, 'move-up')"
                  v-if="isShowUp(scope, treeData) !== 0"
              />
              <a-icon
                  type="arrow-down"
                  @click="onMove(scope, 'move-down')"
                  v-if="isShowDown(scope, treeData)"
              />
              <a-popover
                  :ref="'popover' + scope.deptId"
                  title=""
                  trigger="click"
                  placement="bottom"
              >
                <template slot="content">
                  <div class="input" @click.stop="() => {}">
                    <a-input
                        placeholder="请输入名称，按回车确定"
                        v-model="scope.model"
                        @keyup.enter="addEnded(scope)"
                        :ref="'popoverInput' + scope.deptId"
                        allow-clear
                    >
                      <a-icon
                          slot="suffix"
                          type="enter"
                          style="color: rgba(0, 0, 0, 0.6)"
                      />
                    </a-input>
                    <span @click="cancelPopover(scope)">取消</span>
                  </div>
                </template>
                <a-icon type="plus" @click="openPopover(scope)" />
              </a-popover>
              <a-popover
                  :ref="'popoverE' + scope.deptId"
                  title=""
                  trigger="click"
                  placement="bottom"
              >
                <template slot="content">
                  <div class="input" @click.stop="() => {}">
                    <a-input
                        placeholder="请输入章节名称，按回车确定"
                        v-model="scope.deptName"
                        :ref="'popoverEInput' + scope.deptId"
                        @keyup.enter="addEndedEdit(scope)"
                        allow-clear
                    >
                      <a-icon
                          slot="suffix"
                          type="enter"
                          style="color: rgba(0, 0, 0, 0.6)"
                      />
                    </a-input>
                    <span @click="cancelPopoverEdit(scope)">取消</span>
                  </div>
                </template>
                <a-icon type="edit" @click="openPopoverEdit(scope)" />
              </a-popover>
              <a-icon
                  type="delete"
                  @click="onDel(scope)"
                  v-if="scope.parentId"
              />
            </div>
          </template>
        </a-tree>
        <a-empty v-if="treeData.length === 0"></a-empty>
      </div>
    </div>
  </a-layout>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import {
  deptsDel,
  deptsMoveUp,
  deptsSubmit,
  deptsTree,
  deptsUpdate
} from "@/services/DepartmentServe";
export default {
  components: { Breadcrumb },
  data() {
    return {
      areaTreeFields: {
        title: "deptName",
        value: "deptId",
        key: "deptId",
        children: "subDeptList"
      },
      treeData: []
    };
  },
  mounted() {
    this.getTree();
    document.addEventListener("click", this.handleDocumentClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleDocumentClick);
  },
  methods: {
    handleDocumentClick() {
      this.closePopover();
    },
    closePopover() {
      this.visible = false;
      this.closeTree(this.treeData);
    },
    closeTree(list) {
      list.forEach(scope => {
        if (
            this.$refs["popover" + scope.deptId] &&
            this.$refs["popover" + scope.deptId].visible
        ) {
          this.$refs["popover" + scope.deptId].visible = false;
        }
        if (
            this.$refs["popoverE" + scope.deptId] &&
            this.$refs["popoverE" + scope.deptId].visible
        ) {
          this.$refs["popoverE" + scope.deptId].visible = false;
        }
        if (scope.subDeptList && scope.subDeptList.length > 0) {
          this.closeTree(scope.subDeptList);
        }
      });
    },
    getTree() {
      deptsTree().then(resp => {
        if (resp.data.code === "SUCCESS") {
          this.treeData = [];
          this.$nextTick(() => {
            this.treeData = resp.data.data;
          });
        } else {
          this.$message.error(resp.data.errorMsg || "服务异常");
        }
      });
    },
    onMove(scope, path) {
      deptsMoveUp(scope.deptId, path).then(resp => {
        if (resp.data.code === "SUCCESS") {
          this.$message.success("操作成功");
          this.getTree();
        } else {
          this.$message.error(resp.data.errorMsg);
        }
      });
    },
    isDown(scope, treeData) {
      let obj = {
        index: -1
      };
      treeData.forEach((item, index) => {
        if (item.deptId === scope.deptId) {
          obj = {
            index: index,
            item: item,
            list: treeData
          };
        } else {
          if (
              item.subDeptList &&
              this.isDown(scope, item.subDeptList).index !== -1
          ) {
            obj = this.isDown(scope, item.subDeptList);
          }
        }
      });
      return obj;
    },
    isShowDown(scope, treeData) {
      let obj = this.isDown(scope, treeData);
      if (obj.index === obj.list.length - 1) {
        return false;
      }
      return true;
    },
    isShowUp(scope, treeData) {
      let sort = -1;
      treeData.forEach((item, index) => {
        if (item.deptId === scope.deptId) {
          sort = index;
        } else {
          if (
              item.subDeptList &&
              this.isShowUp(scope, item.subDeptList) !== -1
          ) {
            sort = this.isShowUp(scope, item.subDeptList);
          }
        }
      });
      return sort;
    },
    addEnded(scope) {
      if (!scope.model) {
        this.$message.warn("部门名称不可为空");
        return;
      }
      deptsSubmit({
        parentId: scope.deptId,
        deptName: scope.model
      }).then(resp => {
        if (resp.data.code === "SUCCESS") {
          this.$message.success("新增成功");
          this.$refs["popover" + scope.deptId].visible = false;
          this.getTree();
        } else {
          this.$message.error(resp.data.errorMsg);
        }
      });
    },
    cancelPopover(scope) {
      this.$refs["popover" + scope.deptId].visible = false;
    },
    openPopover(scope) {
      this.cancelPopoverEdit(scope);
      this.$set(scope, "model", "");
      this.$refs["popover" + scope.deptId].visible = true;
      setTimeout(() => {
        this.$refs["popoverInput" + scope.deptId].focus();
      }, 100);
    },
    cancelPopoverEdit(scope) {
      this.$refs["popoverE" + scope.deptId].visible = false;
    },
    addEndedEdit(scope) {
      if (!scope.deptName) {
        this.$message.warn("部门名称不可为空");
        return;
      }
      deptsUpdate({
        deptId: scope.deptId,
        deptName: scope.deptName
      }).then(resp => {
        if (resp.data.code === "SUCCESS") {
          this.$message.success("修改成功");
          this.$refs["popoverE" + scope.deptId].visible = false;
          this.getTree();
        } else {
          this.$message.error(resp.data.errorMsg);
        }
      });
    },
    openPopoverEdit(scope) {
      this.cancelPopover(scope);
      this.$refs["popoverE" + scope.deptId].visible = true;
      setTimeout(() => {
        this.$refs["popoverEInput" + scope.deptId].focus();
      }, 100);
    },
    onDel(scope) {
      this.$confirm({
        title: "是否确认删除部门?",
        okText: "确定",
        okType: "danger",
        cancelText: "取消",
        onOk: () => {
          deptsDel(scope.deptId).then(resp => {
            if (resp.data.code === "SUCCESS") {
              this.$message.success("删除成功");
              this.getTree();
            } else {
              this.$message.error(resp.data.errorMsg);
            }
          });
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.content-container {
  background-color: #fff;
  height: calc(100vh - 250px);
  min-height: 400px;
  padding: 20px;
  overflow-x: auto;

  .tree-com {
    height: calc(100% - 48px);
    width: 400px;
    margin-left: 50px;
    /deep/ .ant-tree-node-content-wrapper {
      position: relative;
      height: auto;
      width: auto;
    }
    /deep/ .ant-tree-node-content-wrapper:hover {
      background-color: var(--accentBackgroundColor) !important;
      color: var(--accentColor);
      transition: all 0.1s;
      position: relative;
    }
    /deep/ .ant-tree-switcher {
      position: relative;
      z-index: 9;
    }
    /deep/ .ant-tree-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      z-index: 3;
      .titleName {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .action {
        position: relative;
        z-index: 9;
        display: none;
        align-items: center;
        font-size: 16px;
        color: #333;
        i {
          margin-left: 12px;
        }
      }
    }
    /deep/.ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
      color: #1677FF !important;
      background: var(--accentBackgroundColor) !important;
      .action {
        display: flex;
        padding-right: 16px;
      }
    }
    /deep/ .ant-tree-node-selected.ant-tree-node-content-wrapper:hover::after {
      background-color: transparent !important;
    }
  }
  /deep/.tree > ul > li > .ant-tree-node-content-wrapper {
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }
}
.input {
  display: flex;
  align-items: center;
  /deep/.ant-input-affix-wrapper {
    width: 250px;
    margin-right: 16px;
  }
}
</style>